<template>
    <div class="body">
      <div class="header">
        <el-form :model="DistributionFindDTO" :inline="true">
          <el-form-item label="上传日期">
            <el-date-picker
              v-model="date"
              type="daterange"
              :picker-options="cellClassName"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              format="yyyy 年 MM 月 dd 日"
              value-format="yyyy-MM-dd"
              @change="chooeDate"
            ></el-date-picker>
          </el-form-item>
          <el-form-item label="订单名称">
              <el-input
                v-model="DistributionFindDTO.orderName"
                placeholder="订单名称"
              ></el-input>
            </el-form-item>
          <el-form-item label="收款账号">
              <el-input
                v-model="DistributionFindDTO.deliveryMethod"
                placeholder="收款账号"
              ></el-input>
            </el-form-item>
          <el-form-item>
            <el-button  type="success" @click="serchInfo" class="btn-search">搜索</el-button>
            <!-- <el-button  size="small" type="primary" @click="tohandleEdit">新增</el-button> -->
            <el-button type="danger" @click="handleDelete" class="btn-delete">删除</el-button>
          </el-form-item>
        </el-form>
        <el-dialog
        text-align="center"
        :close-on-click-modal="false"
        title="新增收款方式"
        :visible.sync="drawer"
        width="25%"
      >
        <el-form
          ref="accountForm"
          :rules="rules"
          :model="accountForm"
          label-width="100px"
          class="demo-accountForm"
        >
          <el-form-item label="发货方式" prop="deliveryMethod">
            <el-input
              class="input-name"
              size="small"
              v-model="accountForm.deliveryMethod"
              placeholder="请输收款账号"
            ></el-input>
          </el-form-item>
        <el-form-item  label="备注" prop="remake">
          <el-input
            class="input-remark"
            v-model="accountForm.remake"
            placeholder="请输入备注"
          ></el-input>
        </el-form-item>

          <el-form-item >
            <el-button
              size="small"
              type="primary"
              @click="submitForm('accountForm')"
            >
              立即创建
            </el-button>
          </el-form-item>
        </el-form>
      </el-dialog>
        <div style="display: flex">

          <!-- <el-button
            size="small"
            style="margin-left: 10px"
            type="primary"
            @click="exportExcelData"
          >
            导出
          </el-button> -->
        </div>
      </div>
      <el-dialog title="编辑收款方式" :visible.sync="dialogVisible"  width="25%" :close-on-click-modal="false">
        <el-form
          ref="accountForm"
          :model="accountForm"
          label-width="100px"
          class="demo-accountForm"
        >
          <el-form-item label="发货方式" prop="deliveryMethod">
            <el-input v-model="accountForm.deliveryMethod" ></el-input>
          </el-form-item>
          <el-form-item label="备注" prop="remake">
            <el-input v-model="accountForm.remake" ></el-input>
          </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button size="small" @click="dialogVisible = false">取 消</el-button>
          <el-button size="small" type="primary" @click="editAccount()">
            确 定
          </el-button>
        </span>
      </el-dialog>
      <div class="pagination">
        <el-pagination
          :current-page="currentPage"
          :page-sizes="[10, 30, 50, 100]"
          :page-size="pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
        ></el-pagination>
      </div>
      <div style="margin: 10px">
        <el-table
          :data="conTract"
          stripe
          border
          style="width: 100%"
          :cell-style="styleBack"
          @selection-change="handleSelectionChange"
        >
        <el-table-column
          type="selection"
          align="center"
          width="55"
        ></el-table-column>
        <el-table-column
            prop="transactionTime"
            align="center"
            label="交易时间"
          ></el-table-column>
          <el-table-column
            prop="orderName"
            align="center"
            label="订单名称"
          ></el-table-column>
          <el-table-column
            prop="transactionType"
            align="center"
            label="交易类型"
          ></el-table-column>
          <el-table-column
            prop="customerName"
            align="center"
            label="交易对象"
          ></el-table-column>
          <el-table-column
            prop="amount"
            align="center"
            label="交易金额"
          ></el-table-column>
          <el-table-column
            prop="collectionAccount"
            align="center"
            label="收款账户"
          ></el-table-column>
          <el-table-column
            prop="operator"
            align="center"
            label="经手人"
          ></el-table-column>
          <el-table-column
          prop="affirmType"
          align="center"
          label="交易状态"
          width="100"
        >     <template slot-scope="scope">
          <el-tag type="warning" v-if="scope.row.affirmType==='0'">未确认</el-tag>
          <el-tag type="success" v-if="scope.row.affirmType==='1'">已确认</el-tag>
      </template>
      </el-table-column>
          <el-table-column
            prop="remarks"
            align="center"
            label="备注"
          ></el-table-column>
               <!-- <el-table-column label="操作" align="center" width="280">
          <template v-slot="{ row }">
            <el-link type="success" size="small" @click="handleEdit(row)">编辑</el-link>
          </template>
        </el-table-column> -->
        </el-table>
      </div>
    
    </div>
  </template>

  <script>
  import { addDistribution,upDateDistribution ,TransactionSelectInfo,bathDeleteDistribution,bathDelete} from '@/api/order/transactionDetails.js'
  export default {
    data() {
      return {
        pageSize: 10,
        total: 0,
        currentPage: 1,
        multipleSelection: [],
        ids: '',
        cellClassName: {
          shortcuts: [
          {
              text: '最近一天',
              onClick(picker) {
                const end = new Date()
                const start = new Date()
                picker.$emit('pick', [start, end])
              }
            },
            {
              text: '最近三天',
              onClick(picker) {
                const end = new Date()
                const start = new Date()
                start.setTime(start.getTime() - 3600 * 1000 * 24 * 2)
                picker.$emit('pick', [start, end])
              }
            },
            {
              text: '最近一周',
              onClick(picker) {
                const end = new Date()
                const start = new Date()
                start.setTime(start.getTime() - 3600 * 1000 * 24 * 6)
                picker.$emit('pick', [start, end])
              }
            },
            {
              text: '最近一个月',
              onClick(picker) {
                const end = new Date()
                const start = new Date()
                start.setTime(start.getTime() - 3600 * 1000 * 24 * 29)
                picker.$emit('pick', [start, end])
              }
            },
            {
              text: '最近三个月',
              onClick(picker) {
                const end = new Date()
                const start = new Date()
                start.setTime(start.getTime() - 3600 * 1000 * 24 * 89)
                picker.$emit('pick', [start, end])
              }
            }
          ]

        },
        date: '',
        conTract: [],
        DistributionFindDTO:{
            startTime: '',
            endTime: '',
            deliveryMethod: '',
            access:'',
            orderName:''
        },
        drawer: false,
        dialogVisible:false,
        accountForm:{
          id:'',
          access:'',
          deliveryMethod:'',
          remake:''
        },
        searchForm: {
          startTime: '',
          secondStartTime: '',
          number: '',
          values: ''
        },
        DeleteDTO:{
          id:'',
          status:''
        },
        rules:{
            deliveryMethod:[
                    { required: true, message: '请输入发货方式', trigger: 'blur' }]
            }
      }
    },
    mounted() {
      this.DistributionFindDTO.access=localStorage.getItem("access")
      this.accountForm.access=localStorage.getItem("access")
      this.getTableData() // 进入页面调用一次获取数据的方法
    },
    methods: {
      styleBack({ row, column, rowIndex, columnIndex }) {
        // if (columnIndex == 0) {
        //   return { color: '#0c87ef' }
        // }
      },
      handleSizeChange(val) {
        this.pageSize = val
        this.getTableData()
      },
      handleCurrentChange(val) {
        this.currentPage = val
        this.getTableData()
      },
      tohandleEdit(){
        this.accountForm = Object.assign({},this.$options.data().accountForm);
        this.accountForm.access=localStorage.getItem("access")
        this.drawer = true
      },
      handleEdit(row) {
        this.dialogVisible = true
        this.accountForm= row
      },
      getTableData() {
        TransactionSelectInfo(this.currentPage, this.pageSize, this.DistributionFindDTO).then((res) => {
          this.conTract = res.data.data.records
          this.total = Number(res.data.data.total)
        })
      },
      submitForm(accountForm) {
        this.$refs[accountForm].validate((valid) => {
          if (valid) {
            addDistribution(this.accountForm).then((res) => {
                  if (res.data.msg === '操作成功') {
              this.drawer = false
              this.$message({
                type: 'success',
                message: '添加成功!',

              }),
              this.getTableData()

            } else if (res.data.msg !== '操作成功') {
              this.$message({
                type: 'info',
                message: res.data.data
              })
            }
            })
          } else {
            return false
          }
        })
      },
   //修改
   editAccount() {
    upDateDistribution(this.accountForm).then((res) => {
          if (res.data.msg === '操作成功') {
              this.$message({
                type: 'success',
                message: '修改成功!',
              }),
              this.getTableData()
              this.dialogVisible = false
            } else if (res.data.msg !== '操作成功') {
              this.$message({
                type: 'info',
                message: res.data.data
              })
            }
        })
      },
      handleDelete(row) {
        if(this.multipleSelection.length==0){
              this.$message({
                type: "error",
                message: "sorry,你还没有勾选呢!"
              });
              return;
            }
      this.$confirm('您真的确定要删除吗？\n\n请确认！！！！！', '删除确认', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          bathDelete(this.multipleSelection).then((res) => {
            if (res.data.msg === '操作成功') {
              this.$message({
                type: 'success',
                message: '删除成功!',
              }),
              this.getTableData()

            } else if (res.data.msg !== '操作成功') {
              this.$message({
                type: 'info',
                message: res.data.data
              })
            }
          })
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          })
        })
    },
      deleteInfo(){
        bathDeleteFile(this.multipleSelection).then((res) => {
            if(res.data.code===10000){
              this.getTableData()
            }
        })
      },
      handleSelectionChange(val) {
        this.multipleSelection = val;
      },
      // 导出
      exportExcelData() {
        exportData(this.searchForm, this.currentPage, this.total)
          .then((res) => {
            if (res.status == 200) {
              exportExcel(res.data, res)
              this.$message({
                type: 'success',
                message: '导出成功!'
              })
            }
          })
          .catch((error) => {

          })
      },
      chooeDate(e) {
        if (e) {
          this.DistributionFindDTO.startTime = e[0]
          this.DistributionFindDTO.endTime = e[1]
        } else if (!e) {
          this.DistributionFindDTO.startTime = ''
          this.DistributionFindDTO.endTime = ''
        }
      },
      // 搜索
      serchInfo() {
        this.getTableData()
      },

    }
  }
  </script>

  <style lang="scss" scoped>
  .header {
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    margin: 20px;
  }
  .body {
    overflow: auto;
    padding-bottom: 50px;
  }
  .pagination {
    margin-top: 10px;
    margin-right: 20px;
    display: flex;
    justify-content: flex-end;
    align-items: flex-end;
    position: relative;
  }
  .el-pagination ::v-deep.el-pagination__total {
    line-height: 36px;
  }


  .el-date-editor , ::v-deep.el-select .el-input__inner , ::v-deep.el-input .el-input__inner{
      border-radius: 8px;
  }
  .btn-search{
      background: var(--theme-color);
  }
  .btn-delete{
      background: #FF4D4D;
  }
  ::v-deep.el-table thead th{
      background: #EAF4F0;
      color: var(--secondColor);
  }
  </style>
